module.exports = __webpack_public_path__ + "static/media/S2P3_genetic-vs-genomic.a6396be3.mp3";